import { useParams, Link } from "react-router-dom";
import {
    LayoutDashboard, Users, FolderKanban, CheckSquare, Calendar, Wallet,
    FileText, FileSignature, BarChart3, UserCircle2, Building2, Sparkles,
    Settings, ArrowLeft, Wrench,
} from "lucide-react";
import tr from "@/i18n/tr";

const MODULES = {
    "clients":         { label: tr.sidebar.clients,          Icon: Users },
    "projects":        { label: tr.sidebar.projects,         Icon: FolderKanban },
    "tasks":           { label: tr.sidebar.tasks,            Icon: CheckSquare },
    "content-calendar":{ label: tr.sidebar.contentCalendar,  Icon: Calendar },
    "finance":         { label: tr.sidebar.finance,          Icon: Wallet },
    "proposals":       { label: tr.sidebar.proposals,        Icon: FileText },
    "contracts":       { label: tr.sidebar.contracts,        Icon: FileSignature },
    "reports":         { label: tr.sidebar.reports,          Icon: BarChart3 },
    "employees":       { label: tr.sidebar.employees,        Icon: UserCircle2 },
    "departments":     { label: tr.sidebar.departments,      Icon: Building2 },
    "ai-assistant":    { label: tr.sidebar.aiAssistant,      Icon: Sparkles },
    "settings":        { label: tr.sidebar.settings,         Icon: Settings },
};

export default function PlaceholderModule() {
    const { module } = useParams();
    const info = MODULES[module] || { label: "Modül", Icon: LayoutDashboard };
    const Icon = info.Icon;

    return (
        <div className="animate-fade-in">
            <div className="mb-6 flex items-center gap-2 text-sm text-muted-foreground">
                <Link to="/dashboard" className="hover:text-foreground transition-colors">
                    {tr.sidebar.dashboard}
                </Link>
                <span>/</span>
                <span className="text-foreground font-medium">{info.label}</span>
            </div>

            <div className="relative overflow-hidden rounded-3xl border border-border bg-card p-10 md:p-16">
                {/* Decorative background */}
                <div aria-hidden className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[hsl(var(--brand))]/10 blur-3xl" />
                <div aria-hidden className="pointer-events-none absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[hsl(var(--info))]/10 blur-3xl" />

                <div className="relative flex flex-col items-center text-center gap-6 max-w-2xl mx-auto">
                    <div className="flex items-center gap-3">
                        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[hsl(var(--brand))] text-white shadow-brand">
                            <Icon className="h-8 w-8" />
                        </div>
                        <div className="flex h-16 w-16 items-center justify-center rounded-2xl border border-dashed border-border bg-muted/50 text-muted-foreground">
                            <Wrench className="h-7 w-7" />
                        </div>
                    </div>

                    <div>
                        <div className="inline-flex items-center gap-2 rounded-full border border-border bg-muted/60 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-4">
                            <span className="h-1.5 w-1.5 rounded-full bg-[hsl(var(--brand))] animate-pulse" />
                            {tr.placeholder.underDevelopment}
                        </div>
                        <h1 className="text-3xl md:text-4xl font-bold tracking-tight">
                            {info.label}
                        </h1>
                        <p className="mt-3 text-muted-foreground text-[15px] leading-relaxed">
                            {tr.placeholder.comingSoon}
                        </p>
                        <p className="mt-2 text-muted-foreground/80 text-sm">
                            {tr.placeholder.stayTuned}
                        </p>
                    </div>

                    <Link
                        to="/dashboard"
                        className="btn-brand mt-2"
                        data-testid="placeholder-back"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        {tr.sidebar.dashboard}&apos;ne dön
                    </Link>
                </div>
            </div>
        </div>
    );
}
